module.exports = "https://callcenter.pagoefectivolatam.com/cuotealo.5a0e5c00fece80c33800d82ce6ddfdc6.png";